import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { KEYS } from '../Constants/Constants';
import { getCookie } from '../Utils/CookieUtils';
import { isMobileWithoutContext } from '../Utils/DeviceInfo';

export const initFirebase = () => {
  const firebaseConfig = {
    apiKey: KEYS?.FIREBASE_CONFIG_API_KEY,
    authDomain: KEYS?.FIREBASE_CONFIG_AUTH_DOMAIN,
    projectId: KEYS?.FIREBASE_CONFIG_PROJECT_ID,
    storageBucket: KEYS?.FIREBASE_CONFIG_STORAGE_BUCKET,
    messagingSenderId: KEYS?.FIREBASE_CONFIG_MESSAGING_SENDER_ID,
    appId: KEYS?.FIREBASE_CONFIG_APP_ID,
    measurementId: KEYS?.FIREBASE_CONFIG_MEASUREMENT_ID,
  };
  initializeApp(firebaseConfig);
};

/**
 *
 * LogEvent Method used to log events
 *
 * @param name
 * @param parameters
 */
export const fbLogEvent = (name: string, parameters: object) => {
  // const storeData = store.getState();
  const authProviderObjectId = getCookie('authProviderObjectId') || '';
  const session = getSessionId(getCookie('session_info')) || '';
  let params: any = parameters;
  params = {
    ...params,
    ...(typeof authProviderObjectId !== 'undefined'
      ? { authProviderObjectId: authProviderObjectId }
      : {}),
    ...(typeof session !== 'undefined' ? { sessionId: session } : {}),
  };

  // Initialize Analytics and get a reference to the service
  const analytics = getAnalytics();
  logEvent(analytics, name, params);

  // Role based Cohorts Firebase Analytics implementation
  // setUserProperties(analytics, { User_Role: role });
};

const getSessionId = (info: string | undefined): string | undefined => {
  if (!info) return;
  return info?.replace('$1', isMobileWithoutContext() ? 'Mobile' : 'Web');
};
